import { createItemByIdOnceHook } from 'modules/utils/helpers/createItemByIdOnceHook'
import { createItemListOnceHook } from 'modules/utils/helpers/createItemListOnceHook'
import actions from './duck'
import selectors from './selectors'

export const useFarmerTargetSkuList = createItemListOnceHook(selectors, actions.listRequested)
export const useFarmerTargetSkuByIdOnce = createItemByIdOnceHook(selectors, actions.itemRequested)
